import { createElement, waitFor } from './globalFunctions'
/**
 * Moves `flags-extra` element inside `flags-default` element and adds the `contains-extra` class to the `flags-default` element.
 * @param {*} product Product card element
 */
const mergeFlags = (product) => {
	if (product.hasAttribute('data-flags-merged')) return
	const flagsDefault = product.querySelector('.flags-default')
	const flagsExtra = product.querySelector('.flags-extra')
	if (!flagsDefault || !flagsExtra) return
	flagsDefault.appendChild(flagsExtra)
	flagsDefault.classList.add('contains-extra')
	product.setAttribute('data-flags-merged', '')
}

/**
 * Moves the `price-standard` element inside the `prices` element.
 * @param {*} product Product card element
 */
const movePriceStandard = (product) => {
	if (product.hasAttribute('data-price-standard-moved')) return
	const prices = product.querySelector('.prices')
	const priceStandard = product.querySelector('.price-standard')
	if (!prices || !priceStandard) return
	prices.appendChild(priceStandard)
	product.setAttribute('data-price-standard-moved', '')
}

/**
 * Creates numeric ratings from the stars value.
 * @param {*} product Product card element
 * @param {*} whereToAppend Element where the ratings should be appended
 */
const createNumericRagings = (product, whereToAppend = false) => {
	if (product.hasAttribute('data-ratings-created')) return
	const ratingsValue = product.querySelector('.stars-wrapper')
	if (!ratingsValue) return
	const productImage = whereToAppend || product.querySelector('.image')
	const customRatings = document.createElement('div')
	customRatings.classList.add('custom-ratings', 'stars')
	customRatings.innerHTML = `
			${
				ratingsValue.getAttribute('data-micro-rating-value') || 0
			} <span class="star star-on"></span> 
		`
	productImage.appendChild(customRatings)
	product.setAttribute('data-ratings-created', '')
}

/**
 * Moves the `dkLabFavouriteProductDiv` element inside the `whereToAppend` element.
 * @param {*} product Product card element
 * @param {*} whereToAppend Element where the `dkLabFavouriteProductDiv` should be appended
 */
const moveAddToFavorites = (product, whereToAppend) => {
	if (product.hasAttribute('data-favoriteModified')) return
	waitFor('.dkLabFavouriteProductDiv').then(() => {
		const addToFavoritesWrap = product.querySelector(
			'.dkLabFavouriteProductDiv'
		)
		if (!addToFavoritesWrap || !whereToAppend) return
		product.setAttribute('data-favoriteModified', 'true')
		if (window.innerWidth > 767) {
			whereToAppend.appendChild(addToFavoritesWrap)
		} else {
			const pTools = product.querySelector('.p-tools')
			if (pTools) {
				pTools.prepend(addToFavoritesWrap)
				pTools.classList.add('has-favorite')
			}
		}
	})
}
// Puts the flags element after the image element in a product card.
const moveFlagsAfterImage = (product) => {
	const flags = product.querySelector('.flags')
	const pIn = product.querySelector('.p-in')
	if (!flags || !pIn) return
	pIn.prepend(flags)
}

// Moves the availability element to the prices element in a product card.
const moveAvailabilityToPrices = (product) => {
	const prices = product.querySelector('.prices')
	const availability = product.querySelector('.availability')
	if (!prices || !availability) return
	prices.appendChild(availability)
}

// Moves the description element to the top of p-in-in in a product card.
const moveDescriptionToTop = (product) => {
	const description = product.querySelector('.p-desc')
	const pInIn = product.querySelector('.p-in-in')
	if (!description || !pInIn) return
	pInIn.prepend(description)
}

const handleDetailBtn = (product) => {
	const detailBtn = product.querySelector('.p-tools a.btn')
	if (detailBtn) {
		detailBtn.textContent =
			window.language === 'cs' ? 'Zobrazit detail' : 'Zobraziť detail'
	} else {
		if (product.querySelector('.p-extra-wrapper')) return
		const btnWrapper = createElement('div', ['p-extra-wrapper'])
		const addedDetailBtn = createElement(
			'a',
			['btn', 'btn-primary'],
			window.language === 'cs' ? 'Zobrazit detail' : 'Zobraziť detail'
		)
		const pInIn = product.querySelector('.p-in-in')
		const name = product.querySelector('.name')
		if (name) addedDetailBtn.href = name.href
		if (!pInIn) return
		btnWrapper.appendChild(addedDetailBtn)
		pInIn.appendChild(btnWrapper)
	}
}

const handleBtnInput = (product) => {
	const inputAmount = product.querySelector('.p-tools input[name="amount"]')
	// const btnWrapper = product.querySelector('.p-extra-wrapper')
	const form = product.querySelector('.p-tools form')
	if (!inputAmount) return

	inputAmount.setAttribute('type', 'number')
	if (inputAmount.value > 1) inputAmount.setAttribute('min', inputAmount.value)
	else inputAmount.setAttribute('min', 1)

	inputAmount.setAttribute('max', 9999)
	inputAmount.setAttribute(
		'aria-label',
		window.language === 'cs' ? 'Množství' : 'Množstvo'
	)

	inputAmount.classList.add('amount')
	const quantity = createElement('span', ['quantity'])
	const increase = createElement('span', ['increase'])
	const decrease = createElement('span', ['decrease'])
	const increaseSpan = createElement('span', ['increase__sign'])
	const decreaseSpan = createElement('span', ['decrease__sign'])
	increase.setAttribute('role', 'button')
	decrease.setAttribute('role', 'button')
	increase.setAttribute(
		'aria-label',
		window.language === 'cs' ? 'Zvýšit množství' : 'Zvýšiť množstvo'
	)
	decrease.setAttribute(
		'aria-label',
		window.language === 'cs' ? 'Snížit množství' : 'Znížiť množstvo'
	)
	increase.appendChild(increaseSpan)
	decrease.appendChild(decreaseSpan)
	quantity.appendChild(inputAmount)
	quantity.appendChild(increase)
	quantity.appendChild(decrease)
	form.appendChild(quantity)
	// if (btnWrapper) {
	// 	btnWrapper.appendChild(quantity)
	// } else {
	// 	const newBtnWrapper = createElement('div', ['p-extra-wrapper'])
	// 	newBtnWrapper.appendChild(quantity)
	// 	product.querySelector('.p-in-in').appendChild(newBtnWrapper)
	// }
}

export {
	mergeFlags,
	movePriceStandard,
	createNumericRagings,
	moveAddToFavorites,
	moveFlagsAfterImage,
	moveAvailabilityToPrices,
	moveDescriptionToTop,
	handleDetailBtn,
	handleBtnInput,
}
